import { makeAutoObservable } from "mobx";
import { getFeatures } from "../http/featuresAPI";

class FeaturesStore {
  features = {};
  loading = false;
  error = null;

  constructor() {
    makeAutoObservable(this);
  }

  async loadFeatures() {
    this.loading = true;
    this.error = null;
    try {
      this.features = await getFeatures();
    } catch (e) {
      this.error = e;
    } finally {
      this.loading = false;
    }
  }

  getFeature(key) {
    return this.features[key];
  }
}

export default FeaturesStore;
